export interface Analytics {
  canSend: boolean
  Event: string
  FormID: string
  FormState?: 'finish' | 'start' | 'scoring_result' | 'phone_sent'
  FormType: string
  LoanAmount?: number
  LoanInstAmount?: number
  LoanInsurance?: 'insured' | 'not_insured'
  LoanIntRate?: number
  LoanRpsn?: number
  LoanTerm?: number
  PageName?: string
  Product: string
  ScoringResult?: string
  TnID?: string
}

export const initialState: Analytics = {
  canSend: true,
  Event: 'VirtualPageView',
  FormID: 'WS Expres pujcka',
  FormState: undefined,
  FormType: 'WS',
  LoanAmount: undefined,
  LoanInstAmount: undefined,
  LoanInsurance: undefined,
  LoanIntRate: undefined,
  LoanRpsn: undefined,
  LoanTerm: undefined,
  PageName: undefined,
  Product: 'Expres pujcka',
  ScoringResult: undefined,
  TnID: undefined,
}
